import PageHeader from 'src/core/ui/PageHeader';
import Footer from 'src/core/ui/helpers/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/core/ui/ContentCard';
import { CustomDataGrid } from 'src/core/tables/CustomDataGrid';
import { generateTablePageButtons } from 'src/core/tables/generateTablePageButtons';
import { useInvoicesTable } from 'src/pages/orders/payments/invoices/useInvoicesTable';

export const InvoicesTablePage = () => {
  const [columns, tableSettings] = useInvoicesTable();
  return (
    <>
      <PageHeader title={'Invoices'} subTitle={'Create, Print and manage invoices'} components={[...generateTablePageButtons(tableSettings)]} />
      <ContentCardsContainer>
        <ContentCard {...{ cardTypes: [CardType.noHeader], contentPadding: 0 }}>
          <CustomDataGrid columns={columns} tableSettings={tableSettings} />
        </ContentCard>
      </ContentCardsContainer>
      <Footer />
    </>
  );
};
export default InvoicesTablePage;
